export default "__VITE_ASSET__CD$XYIi8__"